import Validator from "validatorjs";

export const validate = (props) => {
  const rules = {
    street: [`regex:/^[Aa-zA-Z\\d\\s-.,']*$`],
    street2: [`regex:/^[Aa-zA-Z\\d\\s-.,']*$`],
    city: [`regex:/^[a-zA-Z]+(?:(?:\\s+\\|-)[a-zA-Z]+)*$`],
    zip: [`regex:/^\\d{5}(?:[-\\s]\\d{4})?$`],
    phone: [
      `regex:/^1?\\W*([2-9][0-8][0-9])\\W*([2-9][0-9]{2})\\W*([0-9]{4})(\\se?x?t?(\\d*))?$`,
    ],
  };

  const errorMessages = {
    "regex.street": "Street is invalid.",
    "regex.street2": "Apt is invalid.",
    "regex.city": "City is invalid.",
    "regex.zip": "Zip code is invalid.",
    "regex.phone": "Phone is invalid.",
  };

  const validator = new Validator(props, rules, errorMessages);

  validator.passes();
  return validator.errors.all();
};

export const checkIfEmpty = (props) => {
  const rules = {
    street: "required",
    city: "required",
    zip: "required",
    state: "required",
    phone: "required",
  };

  const errorMessages = {
    "required.street": "Street is required.",
    "required.city": "City is required.",
    "required.zip": "Zip code is required.",
    "required.phone": "Phone is required.",
  };

  const validator = new Validator(props, rules, errorMessages);

  validator.passes();
  return validator.errors.all();
};

export const normalizePhone = (value) => {
  if (!value) {
    return value;
  }

  const onlyNums = value.replace(/[^\d]/g, "");

  if (onlyNums.length <= 3) {
    return onlyNums;
  }

  if (onlyNums.length <= 7) {
    return `${onlyNums.slice(0, 3)}-${onlyNums.slice(3)}`;
  }

  return `${onlyNums.slice(0, 3)}-${onlyNums.slice(3, 6)}-${onlyNums.slice(
    6,
    10
  )}`;
};

export const stripPhoneFormatting = (phone) => phone.split("-").join("");
